import React, { useEffect, useRef } from 'react';
import { initFlowPetRPG } from './flowPetApp';

function FlowPetRPG() {
  const mountRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!mountRef.current) {
      return undefined;
    }

    return initFlowPetRPG(mountRef.current);
  }, []);

  return (
    <>
      <section className="flow-pet-project-intro" aria-labelledby="flow-pet-project-title">
        <p className="flow-pet-project-kicker">Personal Project</p>
        <h1 id="flow-pet-project-title">Flow Pet RPG</h1>
        <p>
          A local-first focus timer that turns deep work into a lightweight RPG loop: complete focus
          quests, earn EXP, evolve a companion, unlock equipment, and protect progress with tab-neglect
          rules.
        </p>
        <ul>
          <li>Web Worker countdowns for reliable timer ticks outside the main UI render loop.</li>
          <li>Focus validation using page visibility and window focus before awarding EXP.</li>
          <li>Persistent progression with pet stages, loot milestones, health, inventory, and equipment.</li>
        </ul>
      </section>
      <div ref={mountRef} />
    </>
  );
}

export default FlowPetRPG;
